/**
 * Stores the list of valid parent-child marsupial pairs
 * note that not every child is compatible with every parent
 */
export const validParents: {[parent: string]: Array<string>} = {
  X1_SENSOR_CONFIG_1: [
    'MARBLE_QAV500_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_2',
    'X3_SENSOR_CONFIG_3',
    'X3_SENSOR_CONFIG_4',
    'X3_SENSOR_CONFIG_5',
    'CERBERUS_GAGARIN_SENSOR_CONFIG_1',
    'CERBERUS_RMF_SENSOR_CONFIG_1',
    'CORO_PAM_SENSOR_CONFIG_1',
    'COSTAR_SHAFTER_SENSOR_CONFIG_1',
    'CTU_CRAS_NORLAB_X500_SENSOR_CONFIG_1',
    'CORO_CRYSTAL_SENSOR_CONFIG_1',
  ],
  X1_SENSOR_CONFIG_2: [
    'MARBLE_QAV500_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_2',
    'X3_SENSOR_CONFIG_3',
    'X3_SENSOR_CONFIG_4',
    'X3_SENSOR_CONFIG_5',
    'CERBERUS_GAGARIN_SENSOR_CONFIG_1',
    'CERBERUS_RMF_SENSOR_CONFIG_1',
    'CORO_PAM_SENSOR_CONFIG_1',
    'COSTAR_SHAFTER_SENSOR_CONFIG_1',
    'CTU_CRAS_NORLAB_X500_SENSOR_CONFIG_1',
    'CORO_CRYSTAL_SENSOR_CONFIG_1',
  ],
  X1_SENSOR_CONFIG_3: [
    'MARBLE_QAV500_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_2',
    'X3_SENSOR_CONFIG_3',
    'X3_SENSOR_CONFIG_4',
    'X3_SENSOR_CONFIG_5',
    'CERBERUS_GAGARIN_SENSOR_CONFIG_1',
    'CERBERUS_RMF_SENSOR_CONFIG_1',
    'CORO_PAM_SENSOR_CONFIG_1',
    'COSTAR_SHAFTER_SENSOR_CONFIG_1',
    'CTU_CRAS_NORLAB_X500_SENSOR_CONFIG_1',
    'CORO_CRYSTAL_SENSOR_CONFIG_1',
  ],
  X1_SENSOR_CONFIG_4: [
    'MARBLE_QAV500_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_2',
    'X3_SENSOR_CONFIG_3',
    'X3_SENSOR_CONFIG_4',
    'X3_SENSOR_CONFIG_5',
    'CERBERUS_GAGARIN_SENSOR_CONFIG_1',
    'CERBERUS_RMF_SENSOR_CONFIG_1',
    'CORO_PAM_SENSOR_CONFIG_1',
    'COSTAR_SHAFTER_SENSOR_CONFIG_1',
    'CTU_CRAS_NORLAB_X500_SENSOR_CONFIG_1',
    'CORO_CRYSTAL_SENSOR_CONFIG_1',
  ],
  X1_SENSOR_CONFIG_5: [
    'MARBLE_QAV500_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_2',
    'X3_SENSOR_CONFIG_3',
    'X3_SENSOR_CONFIG_4',
    'X3_SENSOR_CONFIG_5',
    'CERBERUS_GAGARIN_SENSOR_CONFIG_1',
    'CERBERUS_RMF_SENSOR_CONFIG_1',
    'CORO_PAM_SENSOR_CONFIG_1',
    'COSTAR_SHAFTER_SENSOR_CONFIG_1',
    'CTU_CRAS_NORLAB_X500_SENSOR_CONFIG_1',
    'CORO_CRYSTAL_SENSOR_CONFIG_1',
  ],
  X1_SENSOR_CONFIG_6: [
    'MARBLE_QAV500_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_2',
    'X3_SENSOR_CONFIG_3',
    'X3_SENSOR_CONFIG_4',
    'X3_SENSOR_CONFIG_5',
    'CERBERUS_GAGARIN_SENSOR_CONFIG_1',
    'CERBERUS_RMF_SENSOR_CONFIG_1',
    'CORO_PAM_SENSOR_CONFIG_1',
    'COSTAR_SHAFTER_SENSOR_CONFIG_1',
    'CTU_CRAS_NORLAB_X500_SENSOR_CONFIG_1',
    'CORO_CRYSTAL_SENSOR_CONFIG_1',
  ],
  X1_SENSOR_CONFIG_7: [
    'MARBLE_QAV500_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_2',
    'X3_SENSOR_CONFIG_3',
    'X3_SENSOR_CONFIG_4',
    'X3_SENSOR_CONFIG_5',
    'CERBERUS_GAGARIN_SENSOR_CONFIG_1',
    'CERBERUS_RMF_SENSOR_CONFIG_1',
    'CORO_PAM_SENSOR_CONFIG_1',
    'COSTAR_SHAFTER_SENSOR_CONFIG_1',
    'CTU_CRAS_NORLAB_X500_SENSOR_CONFIG_1',
    'CORO_CRYSTAL_SENSOR_CONFIG_1',
  ],
  X1_SENSOR_CONFIG_8: [
    'MARBLE_QAV500_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_2',
    'X3_SENSOR_CONFIG_3',
    'X3_SENSOR_CONFIG_4',
    'X3_SENSOR_CONFIG_5',
    'CERBERUS_GAGARIN_SENSOR_CONFIG_1',
    'CERBERUS_RMF_SENSOR_CONFIG_1',
    'CORO_PAM_SENSOR_CONFIG_1',
    'COSTAR_SHAFTER_SENSOR_CONFIG_1',
    'CTU_CRAS_NORLAB_X500_SENSOR_CONFIG_1',
    'CORO_CRYSTAL_SENSOR_CONFIG_1',
  ],
  EXPLORER_X1_SENSOR_CONFIG_1: [
    'MARBLE_QAV500_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_2',
    'X3_SENSOR_CONFIG_3',
    'X3_SENSOR_CONFIG_4',
    'X3_SENSOR_CONFIG_5',
    'CERBERUS_GAGARIN_SENSOR_CONFIG_1',
    'CERBERUS_RMF_SENSOR_CONFIG_1',
    'CORO_PAM_SENSOR_CONFIG_1',
    'COSTAR_SHAFTER_SENSOR_CONFIG_1',
    'CTU_CRAS_NORLAB_X500_SENSOR_CONFIG_1',
    'CORO_CRYSTAL_SENSOR_CONFIG_1',
  ],
  EXPLORER_X1_SENSOR_CONFIG_2: [
    'MARBLE_QAV500_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_2',
    'X3_SENSOR_CONFIG_3',
    'X3_SENSOR_CONFIG_4',
    'X3_SENSOR_CONFIG_5',
    'CERBERUS_GAGARIN_SENSOR_CONFIG_1',
    'CERBERUS_RMF_SENSOR_CONFIG_1',
    'CORO_PAM_SENSOR_CONFIG_1',
    'COSTAR_SHAFTER_SENSOR_CONFIG_1',
    'CTU_CRAS_NORLAB_X500_SENSOR_CONFIG_1',
    'CORO_CRYSTAL_SENSOR_CONFIG_1',
  ],
  EXPLORER_R2_SENSOR_CONFIG_1: [
    'CERBERUS_M100_SENSOR_CONFIG_1',
    'EXPLORER_DS1_SENSOR_CONFIG_1',
    'MARBLE_QAV500_SENSOR_CONFIG_1',
    'SOPHISTICATED_ENGINEERING_X4_SENSOR_CONFIG_1',
    'SSCI_X4_SENSOR_CONFIG_1',
    'SSCI_X4_SENSOR_CONFIG_2',
    'X3_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_2',
    'X3_SENSOR_CONFIG_3',
    'X3_SENSOR_CONFIG_4',
    'X3_SENSOR_CONFIG_5',
    'X4_UAV_CONFIG_1',
    'X4_UAV_CONFIG_2',
    'X4_UAV_CONFIG_3',
    'X4_UAV_CONFIG_4',
    'X4_UAV_CONFIG_5',
    'X4_UAV_CONFIG_6',
    'CERBERUS_GAGARIN_SENSOR_CONFIG_1',
    'CERBERUS_RMF_SENSOR_CONFIG_1',
    'CORO_PAM_SENSOR_CONFIG_1',
    'COSTAR_SHAFTER_SENSOR_CONFIG_1',
    'CTU_CRAS_NORLAB_X500_SENSOR_CONFIG_1',
    'EMESENT_HOVERMAP_SENSOR_CONFIG_1',
    'CORO_CRYSTAL_SENSOR_CONFIG_1',
  ],
  EXPLORER_R2_SENSOR_CONFIG_2: [
    'CERBERUS_M100_SENSOR_CONFIG_1',
    'EXPLORER_DS1_SENSOR_CONFIG_1',
    'MARBLE_QAV500_SENSOR_CONFIG_1',
    'SOPHISTICATED_ENGINEERING_X4_SENSOR_CONFIG_1',
    'SSCI_X4_SENSOR_CONFIG_1',
    'SSCI_X4_SENSOR_CONFIG_2',
    'X3_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_2',
    'X3_SENSOR_CONFIG_3',
    'X3_SENSOR_CONFIG_4',
    'X3_SENSOR_CONFIG_5',
    'X4_UAV_CONFIG_1',
    'X4_UAV_CONFIG_2',
    'X4_UAV_CONFIG_3',
    'X4_UAV_CONFIG_4',
    'X4_UAV_CONFIG_5',
    'X4_UAV_CONFIG_6',
    'CERBERUS_GAGARIN_SENSOR_CONFIG_1',
    'CERBERUS_RMF_SENSOR_CONFIG_1',
    'CORO_PAM_SENSOR_CONFIG_1',
    'COSTAR_SHAFTER_SENSOR_CONFIG_1',
    'CTU_CRAS_NORLAB_X500_SENSOR_CONFIG_1',
    'EMESENT_HOVERMAP_SENSOR_CONFIG_1',
    'CORO_CRYSTAL_SENSOR_CONFIG_1',
  ],
  CSIRO_DATA61_OZBOT_ATR_SENSOR_CONFIG_1: [
    'CERBERUS_M100_SENSOR_CONFIG_1',
    'EXPLORER_DS1_SENSOR_CONFIG_1',
    'MARBLE_QAV500_SENSOR_CONFIG_1',
    'SOPHISTICATED_ENGINEERING_X4_SENSOR_CONFIG_1',
    'SSCI_X4_SENSOR_CONFIG_1',
    'SSCI_X4_SENSOR_CONFIG_2',
    'X3_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_2',
    'X3_SENSOR_CONFIG_3',
    'X3_SENSOR_CONFIG_4',
    'X3_SENSOR_CONFIG_5',
    'X4_UAV_CONFIG_1',
    'X4_UAV_CONFIG_2',
    'X4_UAV_CONFIG_3',
    'X4_UAV_CONFIG_4',
    'X4_UAV_CONFIG_5',
    'X4_UAV_CONFIG_6',
    'CERBERUS_GAGARIN_SENSOR_CONFIG_1',
    'CERBERUS_RMF_SENSOR_CONFIG_1',
    'CORO_PAM_SENSOR_CONFIG_1',
    'COSTAR_SHAFTER_SENSOR_CONFIG_1',
    'CTU_CRAS_NORLAB_X500_SENSOR_CONFIG_1',
    'EMESENT_HOVERMAP_SENSOR_CONFIG_1',
    'CORO_CRYSTAL_SENSOR_CONFIG_1',
  ],
  CSIRO_DATA61_OZBOT_ATR_SENSOR_CONFIG_2: [
    'CERBERUS_M100_SENSOR_CONFIG_1',
    'EXPLORER_DS1_SENSOR_CONFIG_1',
    'MARBLE_QAV500_SENSOR_CONFIG_1',
    'SOPHISTICATED_ENGINEERING_X4_SENSOR_CONFIG_1',
    'SSCI_X4_SENSOR_CONFIG_1',
    'SSCI_X4_SENSOR_CONFIG_2',
    'X3_SENSOR_CONFIG_1',
    'X3_SENSOR_CONFIG_2',
    'X3_SENSOR_CONFIG_3',
    'X3_SENSOR_CONFIG_4',
    'X3_SENSOR_CONFIG_5',
    'X4_UAV_CONFIG_1',
    'X4_UAV_CONFIG_2',
    'X4_UAV_CONFIG_3',
    'X4_UAV_CONFIG_4',
    'X4_UAV_CONFIG_5',
    'X4_UAV_CONFIG_6',
    'CERBERUS_GAGARIN_SENSOR_CONFIG_1',
    'CERBERUS_RMF_SENSOR_CONFIG_1',
    'CORO_PAM_SENSOR_CONFIG_1',
    'COSTAR_SHAFTER_SENSOR_CONFIG_1',
    'CTU_CRAS_NORLAB_X500_SENSOR_CONFIG_1',
    'EMESENT_HOVERMAP_SENSOR_CONFIG_1',
    'CORO_CRYSTAL_SENSOR_CONFIG_1',
  ],
  CORO_ALLIE_SENSOR_CONFIG_1: [
    'CERBERUS_RMF_SENSOR_CONFIG_1',
    'COR_PAM_SENSOR_CONFIG_1',
    'CORO_CRYSTAL_SENSOR_CONFIG_1',
  ],
  CORO_ALLIE_SENSOR_CONFIG_2: [
    'CERBERUS_RMF_SENSOR_CONFIG_1',
    'COR_PAM_SENSOR_CONFIG_1',
    'CORO_CRYSTAL_SENSOR_CONFIG_1',
  ],
  CORO_KAREN_SENSOR_CONFIG_1: [
    'CERBERUS_RMF_SENSOR_CONFIG_1',
    'COR_PAM_SENSOR_CONFIG_1',
    'CORO_CRYSTAL_SENSOR_CONFIG_1',
  ],
  CORO_KAREN_SENSOR_CONFIG_2: [
    'CERBERUS_RMF_SENSOR_CONFIG_1',
    'COR_PAM_SENSOR_CONFIG_1',
    'CORO_CRYSTAL_SENSOR_CONFIG_1',
  ],
  CORO_JEANINE_SENSOR_CONFIG_1: [
    'CERBERUS_RMF_SENSOR_CONFIG_1',
    'COR_PAM_SENSOR_CONFIG_1',
    'CORO_CRYSTAL_SENSOR_CONFIG_1',
  ],
  CORO_JEANINE_SENSOR_CONFIG_2: [
    'CERBERUS_RMF_SENSOR_CONFIG_1',
    'COR_PAM_SENSOR_CONFIG_1',
    'CORO_CRYSTAL_SENSOR_CONFIG_1',
  ],
  CORO_MIKE_SENSOR_CONFIG_1: [
    'CERBERUS_RMF_SENSOR_CONFIG_1',
    'COR_PAM_SENSOR_CONFIG_1',
    'CORO_CRYSTAL_SENSOR_CONFIG_1',
  ],
};
